const x = ({ ref: i, searchRef: u }) => (e) => {
  var c, l;
  const s = (c = i.current) == null ? void 0 : c.closest('[role="listbox"]'), f = e.currentTarget;
  if (s) {
    const o = s.querySelectorAll('[role="option"]'), r = o[0];
    let n = -1;
    if (o.forEach((t, p) => {
      t === f && (n = p);
    }), e.key === "ArrowDown") {
      e.preventDefault();
      const t = o[n + 1];
      t ? t.focus() : r == null || r.focus();
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
      const t = o[n - 1];
      t ? t.focus() : (l = u.current) == null || l.focus();
    }
  }
};
export {
  x as useListboxOptionOnKeyUp
};
